import { gql } from "@apollo/client";

export const GET_ERRORS = gql`
	query GetErrors($mailSetId: UUID!) {
		errors(input: { mailSetId: $mailSetId })
	}
`;
